export function fileExtension(filename: string): string | undefined {
  const lastDot = filename.lastIndexOf(".")
  if (lastDot <= 0) return undefined
  const extension = filename.slice(lastDot + 1).trim().toLowerCase()
  return extension.length > 0 ? extension : undefined
}
